import React, { useEffect, useState } from "react";
import QueryString from "qs";
import { authAxiosInstance } from "../../utils/axiosConfig";

export const QuotationTemplatesImages = ({
    quotationTemplateData,
    setPreviewModalOpen,
    setPreviewImg,
}) => {
    if (!quotationTemplateData) {
        return null;
    }

    return (
        <div className="flex flex-col sm:flex-row gap-4 p-3 border rounded-md">

            {/* Header Image */}
            <div
                className="flex flex-col items-center gap-1"
                onClick={(e) => {
                    e.stopPropagation();

                    setPreviewModalOpen(true);

                    setPreviewImg(
                        quotationTemplateData?.headerImg
                            ? [quotationTemplateData.headerImg]
                            : []
                    );
                }}
            >
                <p className="text-sm font-medium">
                    Header Image
                </p>

                {quotationTemplateData?.headerImg ? (
                    <img
                        src={`${process.env.REACT_APP_S3_URL}${quotationTemplateData.headerImg}`}
                        alt="Header Image"
                        className="w-24 h-24 object-contain rounded cursor-pointer border hover:opacity-80"
                    />
                ) : (
                    <div className="w-24 h-24 flex items-center justify-center border rounded text-xs text-gray-400">
                        No Image
                    </div>
                )}
            </div>

            {/* Footer Image */}
            <div
                className="flex flex-col items-center gap-1"
                onClick={(e) => {
                    e.stopPropagation();

                    setPreviewModalOpen(true);

                    setPreviewImg(
                        quotationTemplateData?.footerImg
                            ? [quotationTemplateData.footerImg]
                            : []
                    );
                }}
            >
                <p className="text-sm font-medium">
                    Footer Image
                </p>

                {quotationTemplateData?.footerImg ? (
                    <img
                        src={`${process.env.REACT_APP_S3_URL}${quotationTemplateData.footerImg}`}
                        alt="Footer Image"
                        className="w-24 h-24 object-contain rounded cursor-pointer border hover:opacity-80"
                    />
                ) : (
                    <div className="w-24 h-24 flex items-center justify-center border rounded text-xs text-gray-400">
                        No Image
                    </div>
                )}
            </div>

            {/* Terms Images */}
            <div
                className="flex flex-col items-center gap-1"
                onClick={(e) => {
                    e.stopPropagation();

                    setPreviewModalOpen(true);

                    setPreviewImg(
                        quotationTemplateData?.termsImg || []
                    );
                }}
            >
                <p className="text-sm font-medium">
                    Terms Images
                </p>

                {quotationTemplateData?.termsImg?.length > 0 ? (
                    <img
                        src={`${process.env.REACT_APP_S3_URL}${quotationTemplateData.termsImg[0]}`}
                        alt="Terms Image"
                        className="w-24 h-24 object-contain rounded cursor-pointer border hover:opacity-80"
                    />
                ) : (
                    <div className="w-24 h-24 flex items-center justify-center border rounded text-xs text-gray-400">
                        No Image
                    </div>
                )}
            </div>
        </div>
    );
};